// extracted by mini-css-extract-plugin
module.exports = {"container":"mix_container_1LOTQ","content":"mix_content_1hTuv","details":"mix_details_2NKZK","subtitle":"mix_subtitle_28UeF"};